import { getS3Bucket } from './../../../../containers/Domains';

export const getFilenameWithoutExtension = (filename) => {
  if (!filename) return '';

  // assume last word after . is the extension..
  let countFromEnd = 0;
  for (let i = filename.length - 1; i >= 0; i -= 1) {
    if (filename[i] === '.') {
      countFromEnd += 1;
      break;
    }

    countFromEnd += 1;
  }

  const resultFilename = filename.substr(0, filename.length - countFromEnd);

  return resultFilename;
};

export const getFilename = (asset, lengthLimit = 25) => {
  const { filename } = asset || {};

  const resultFilename = getFilenameWithoutExtension(filename);

  if (resultFilename.length > lengthLimit) {
    return `${resultFilename.substr(0, lengthLimit)}...`;
  }

  return resultFilename;
};

export const getUploadedBy = (asset, lengthLimit = 15) => {
  const { uploaded_by: uploadedBy } = asset || {};

  if (!uploadedBy) return '-';

  if (uploadedBy.length > lengthLimit) {
    return `${uploadedBy.substr(0, lengthLimit)}...`;
  }

  return uploadedBy;
};

/**
 *
 * It returns 'image/{png | jpg | jpeg ...} or video/mp4.
 * If file is in the asset paramter, user its type.
 * @param {object} asset
 */
export const getFileType = (asset) => {
  const { file } = asset || {};

  const { type } = file || asset || {};

  if (!type) return '-';

  return `${type}`;
};

/**
 * This function returns the file size in MB. The original filen size should be in bytes.
 *
 * @param {object} file
 */
export const getFileSize = (asset) => {
  const { file } = asset;
  const { size } = file;

  const square = 1024 ** 2;

  return `${Math.ceil(size / square)} MB`;
};

export const getAssetUrl = (asset) => {
  if (!asset) return '';

  const { filename, guid, id } = asset;
  const s3Url = getS3Bucket();
  const fileExtension = `${filename.split('.').slice(-1)}`;

  if (!fileExtension) {
    throw new Error(
      `File extension cannot be extracted for the asset. Asset id: ${id}`
    );
  }

  let assetUrl = '';

  if (guid) assetUrl = `${s3Url}${guid}.${fileExtension}`;
  else assetUrl = `${s3Url}${filename}`;

  return assetUrl;
};



// WEBPACK FOOTER //
// ./src/components/common/AssetGalleryV2/Utils/asset.utils.js